import { BaseApiService } from "./baseApi";

export type TextProviderId = "anthropic" | "openai" | "gemini";

export type TextModel = { id: string; label: string };

export type TextProviderInfo = {
  id: TextProviderId;
  label: string;
  envKey: string;
  hasKey: boolean;
  models: TextModel[];
};

export type ImageProviderInfo = {
  id: string;
  label: string;
  envKey: string;
  hasKey: boolean;
};

export type ProvidersEnabled = {
  anthropic: boolean;
  openai: boolean;
  gemini: boolean;
  replicate: boolean;
  pollinations: boolean;
  huggingface: boolean;
};

export type MarketingConfig = {
  textProvider: TextProviderId;
  textModel: string;
  imageProvider: string;
  providersEnabled: ProvidersEnabled;
  updatedAt?: string;
  updatedBy?: string;
};

export type MarketingConfigResponse = {
  success: boolean;
  config: MarketingConfig;
  catalog: {
    textProviders: TextProviderInfo[];
    imageProviders: ImageProviderInfo[];
  };
};

export type UpdateMarketingConfigPayload = Partial<{
  textProvider: TextProviderId;
  textModel: string;
  imageProvider: string;
  providersEnabled: Partial<ProvidersEnabled>;
}>;

class MarketingApiService extends BaseApiService {
  async getConfig(): Promise<MarketingConfigResponse> {
    return this.get<MarketingConfigResponse>("/marketing/admin/config");
  }

  async updateConfig(
    payload: UpdateMarketingConfigPayload
  ): Promise<{ success: boolean; config: MarketingConfig }> {
    return this.put<{ success: boolean; config: MarketingConfig }>(
      "/marketing/admin/config",
      payload
    );
  }
}

export const marketingApi = new MarketingApiService();
